import { useEffect, useState } from 'react';
import styles from '../../../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Modal from '@mui/material/Modal';
import Base from '../../../../../../Base/Base';
import Spinner from '../../../../../../../components/UI/Spinner/Spinner';
import ApiErrors from '../../../../../components/NewApplication/ApiErrors';
import Section from '../../../../../components/NewApplication/Section';
import classNames from 'classnames';
import ExtensionTypeSelect from '../../../../../components/ExtensionTypeSelect';
import { AppData } from '../../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import Switch from '@mui/material/Switch';
import AppDataUpdateRequest from '../../../../../../../Classes/ResponseModels/ApplicationManagement/AppDataUpdateRequest';
import { CreateAppData, UpdateAppData } from '../../../../../_api';
const AppDataForm = ({
	appData = new AppData(),
	app,
	currentUser,
	component,
	reload,
	readOnly,
	requirementNumber,
}) => {
	//isNew: indicates whether or not the form is for a new component or a
	const isNew = appData?.id == null;
	const [modalOpen, setModalOpen] = useState(false);
	const [localAppData, setLocalAppData] = useState({ ...appData });
	const [apiErrors, setApiErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [validationErrors, setValidationErrors] = useState([]);

	useEffect(() => {
		//set defaults for new AppData

		if (isNew) {
			setLocalAppData({
				...appData,
				search: app.appMaster.id,
				componentID: component?.id,
				orderBy: null,
				activeFlag: true,
				privilegedFlag: false,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setValidationErrors(AppData.validate(localAppData));
	}, [localAppData]);

	const handleSave = () => {
		let request = new AppDataUpdateRequest(app, currentUser, localAppData);
		request.requirementNumber = requirementNumber;
		setIsLoading(true);
		if (isNew) {
			CreateAppData(request).then(response => {
				if (response.App?.Errors?.length > 0) {
					setApiErrors(response.App.Errors);
					setIsLoading(false);
				} else {
					setIsLoading(false);
					reload();
				}
			});
		} else {
			UpdateAppData(request).then(response => {
				if (response.App?.Errors?.length > 0) {
					setApiErrors(response.App.Errors);
					setIsLoading(false);
				} else {
					setIsLoading(false);
					reload();
				}
			});
		}
	};

	const handleExtensionTypeChange = e => {
		setLocalAppData({
			...localAppData,
			extension:
				e.target.value != null
					? {
							fiid: e.target.value,
					  }
					: null,
		});
	};

	const handleChange = e => {
		setLocalAppData({
			...localAppData,
			[e.target.name]: e.target.value,
		});
	};

	const resolveTextAreaNull = value => {
		if (value !== null) {
			return value;
		} else {
			return '';
		}
	};

	const handleCheckboxChange = e => {
		setLocalAppData({
			...localAppData,
			[e.target.name]: e.target.checked,
		});
	};

	return (
		<div>
			<div>
				<div className={styles.controlsContainer}>
					<Button
						id='app_AppDataForm_modal_open'
						onClick={() => setModalOpen(true)}
						startIcon={
							isNew ? (
								<MaterialIcon icon='add' />
							) : (
								<MaterialIcon icon='edit' />
							)
						}
						disabled={readOnly}
					>
						{isNew ? 'Add Data' : 'Update'}
					</Button>
				</div>
				<Modal
					open={modalOpen}
					onClose={() => {
						setApiErrors([]);
						setLocalAppData({ ...appData });
						setModalOpen(false);
					}}
				>
					<div className={styles.Modal}>
						<Base title='Application Data'>
							{isLoading ? (
								<Spinner />
							) : (
								<>
									<ApiErrors errors={apiErrors} />
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											startIcon={
												<MaterialIcon icon='save' />
											}
											id='AppData_Save'
											disabled={
												readOnly ||
												validationErrors.length > 0
											}
										>
											Save
										</Button>
									</div>

									<Section label='App Data'>
										<ExtensionTypeSelect
											extensionTypes={
												app.extensions ?? []
											}
											handleChange={e => {
												handleExtensionTypeChange(e);
											}}
											extensionID={
												localAppData.extension?.fiid ??
												0
											}
										/>

										{/* Search : string (32) */}
										<div className={styles.detailLabel}>
											<p>
												Search{' '}
												<span
													className={styles.sub_label}
												>
													(app ID by default)
												</span>
												<br />
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localAppData.search
												)}
												onChange={e => handleChange(e)}
												name='search'
												maxLength={32}
												rows={1}
												id='appData_search'
											/>
										</div>
										{/* full : string (255) */}
										<div className={styles.detailLabel}>
											<p>
												Full <br />
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localAppData?.full
														? localAppData.full
																.length
														: 0}
													/{255})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localAppData.full
												)}
												onChange={e => handleChange(e)}
												name='full'
												maxLength={255}
												rows={5}
												id='appData_full'
											/>
											<p className={styles.error}>
												{
													validationErrors.find(
														error =>
															error.field ===
															'full'
													)?.message
												}
											</p>
										</div>
										{/* short : string (32) */}
										<div className={styles.detailLabel}>
											<p>
												Short <br />
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localAppData?.short
														? localAppData.short
																.length
														: 0}
													/{255})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localAppData.short
												)}
												onChange={e => handleChange(e)}
												name='short'
												maxLength={255}
												rows={5}
												id='appData_short'
											/>
											<p className={styles.error}>
												{
													validationErrors.find(
														error =>
															error.field ===
															'short'
													)?.message
												}
											</p>
										</div>
										{/* description : string (255) */}
										<div className={styles.detailLabel}>
											<p>
												Description
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localAppData?.description
														? localAppData
																.description
																.length
														: 0}
													/{255})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localAppData.description
												)}
												onChange={e => handleChange(e)}
												name='description'
												maxLength={255}
												rows={5}
												id='appData_description'
											/>
											<p className={styles.error}>
												{
													validationErrors.find(
														error =>
															error.field ===
															'description'
													)?.message
												}
											</p>
										</div>
										{/* field value : string (255) */}
										<div className={styles.detailLabel}>
											<p>
												Field Value
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localAppData?.fieldValue
														? localAppData
																.fieldValue
																.length
														: 0}
													/{255})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localAppData.fieldValue
												)}
												onChange={e => handleChange(e)}
												name='fieldValue'
												maxLength={255}
												rows={5}
												id='appData_fieldValue'
											/>
											<p className={styles.error}>
												{
													validationErrors.find(
														error =>
															error.field ===
															'fieldValue'
													)?.message
												}
											</p>
										</div>
										{/* Order By : number */}
										<div className={styles.detailLabel}>
											<p>Order </p>
											<input
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='number'
												value={localAppData.orderBy}
												onChange={e => handleChange(e)}
												name='orderBy'
												id='appData_Order'
											/>
										</div>
										{/* controlType : string (32) */}
										<div className={styles.detailLabel}>
											<p>
												ControlType
												<span
													className={
														styles.characterCount
													}
												>
													(
													{localAppData?.controlType
														? localAppData
																.controlType
																.length
														: 0}
													/{32})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													localAppData.controlType
												)}
												onChange={e => handleChange(e)}
												name='controlType'
												maxLength={32}
												rows={5}
												id='appData_controlType'
											/>
										</div>
										{/*PrivilegedFlag : bool  */}
										<div className={styles.detailLabel}>
											<p>Privileged Flag</p>
											<Switch
												checked={
													localAppData.privilegedFlag
												}
												name='privilegedFlag'
												onClick={e =>
													handleCheckboxChange(e)
												}
												id='appData_privilegedFlag'
											/>
										</div>
									</Section>
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											startIcon={
												<MaterialIcon icon='save' />
											}
											id='appData_Save2'
											disabled={
												readOnly ||
												validationErrors.length > 0
											}
										>
											Save
										</Button>
									</div>
								</>
							)}
						</Base>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default AppDataForm;
